import React from 'react'
import { MdOutlineClose } from "react-icons/md";
import { formatWithOffset } from '../../../_helpers/helper';

const ViewModal = ({ data, onClose }) => {
  const isExpired = (expiredOn) => {
		if (!expiredOn) return false;
		const currentDate = new Date();
		const expiryDate = new Date(expiredOn);
		return currentDate > expiryDate;
	}
  let remarks = [];
  try {
    remarks = JSON.parse(data?.remark || []);
  } catch (error) {
    remarks = [];
  }
  return (
    <div>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-[1000px]  overflow-hidden overflow-y-auto ">

          <div className="flex justify-between items-center border-b py-2 md:px-6 px-4">
            <h2 className="text-xl font-semibold text-gray-800">Customer Details</h2>
            <button onClick={onClose} className="bg-gray-100 hover:bg-gray-200 p-2 rounded-full ">
              <MdOutlineClose size={20} className=' rounded-full' />
            </button>
          </div>
       

          <div className=' h-[30rem] overflow-y-auto'>
          <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2 md:p-6 p-4'>
            <div>
              <label className='block text-sm font-medium text-black'>First Name:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.f_name || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Last Name:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.l_name || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Weighbridge Id:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.id || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Expired On:</label>
              <input disabled type="text" id="l_name" name='l_name' value={formatWithOffset(data.expired_on)} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Referred By Phone:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.referred_by_phone || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Phone:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.phone || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Referred By:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.referred_by_name || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>License Key:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.license_key || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Last Login:</label>
              <input disabled type="text" id="l_name" name='l_name' value={formatWithOffset(data?.last_login) || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>City:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.city || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>State:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.state || null} className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Status:</label>
              <input disabled type="text" id="l_name" name='l_name' value={data?.expire_on_backup ? 'Stoped' : isExpired(data?.expired_on) ? 'Expired' : 'Active'} className={`w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm ${data.status === 1 ? 'text-green-500 font-semibold' : data.status === 2 ? 'text-red-500 font-semibold' : 'text-yellow-500 font-semibold'}`} />
            </div>
            <div>
              <label className='block text-sm font-medium text-black'>Address:</label>
              <div disabled type="text" id="l_name" name='l_name' className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" >{data?.address || null}  </div>
            </div>
            {remarks && Array.isArray(remarks) &&
              remarks.map((r, i) =>
                <div key={i}>
                  <label className='block text-sm font-medium text-black'>Remark {i + 1}:</label>
                  <div disabled type="text" id="l_name" name='l_name' className="w-full mt-0.5 px-3 py-2 border border-gray-300 rounded-md focus:ring focus:ring-indigo-300 focus:outline-none text-sm" >{r.text}</div>
                  <span className="w-full mt-0.5 py-2 focus:ring focus:ring-indigo-300 focus:outline-none text-sm" >{formatWithOffset(r?.timeAdded)}</span>
                </div>
              )}
          </div>
          </div>
          <div className="flex justify-end   border-t md:px-6 p-4">
          <button className="px-4 py-2 text-lg font-medium text-white bgbtn rounded-md transition md:w-40 w-full" onClick={onClose}>
          Close</button>
        </div>
          
        </div>
      </div>
    </div>
  )
}

export default ViewModal